var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3794_7644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87488 6.50073H7.49988V4.12573C7.49988 4.05698 7.44363 4.00073 7.37488 4.00073H6.62488C6.55613 4.00073 6.49988 4.05698 6.49988 4.12573V6.50073H4.12488C4.05613 6.50073 3.99988 6.55698 3.99988 6.62573V7.37573C3.99988 7.44448 4.05613 7.50073 4.12488 7.50073H6.49988V9.87573C6.49988 9.94448 6.55613 10.0007 6.62488 10.0007H7.37488C7.44363 10.0007 7.49988 9.94448 7.49988 9.87573V7.50073H9.87488C9.94363 7.50073 9.99988 7.44448 9.99988 7.37573V6.62573C9.99988 6.55698 9.94363 6.50073 9.87488 6.50073Z",
    fill: "#262641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13437 0 0 3.13437 0 7C0 10.8656 3.13437 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13437 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125Z",
    fill: "#262641"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3794_7644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.55ac68a0ee0e7c2582f50b2de621580b.svg";
export { ForwardRef as ReactComponent };